import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  loading:false,

};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {
      userForgetPasswordSuccess(state, action) {
          // console.log(action.payload)
          state.forgetSuccessMsg = action.payload
          state.loading = false
      },
      userForgetPasswordError(state, action) {
 
          state.forgetError = action.payload
          state.loading = false
      },
      userForgetPassword_Start_Loading(state, action) {
        state.loading = true
      }
  },
});

export const {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userForgetPassword_Start_Loading
} = forgotPasswordSlice.actions

export default forgotPasswordSlice.reducer;
